import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

interface QuestionStatusIndicatorProps {
  explanation: string | undefined;
  color: string | undefined;
}

const QuestionStatusIndicator = ({
  explanation,
  color,
}: QuestionStatusIndicatorProps): JSX.Element => {
  return (
    <Tooltip title={explanation}>
      <Box
        sx={{
          width: 16,
          height: 16,
          borderRadius: '50%',
          flexShrink: 0,
          backgroundColor: color,
        }}
      />
    </Tooltip>
  );
};

export default QuestionStatusIndicator;
